var styles = {
  "Container": "_Container_aua3o_1",
  "Title": "_Title_aua3o_8",
  "Content": "_Content_aua3o_15",
  "Link": "_Link_aua3o_23"
};

export { styles as default };
